import React from 'react';
import ModalContainer from 'components/shared/modal/modal_container';
import request from 'utils/request_ajax';
import { routes } from 'constants/config';
import { withTooltip } from 'components/shared/Tooltip';
import Select from 'components/shared/select';
import { Button, ButtonGroup, Icon } from 'ui';
import ScormUploader from './ScormUploader';
import SelectWorkspace from '../SelectWorkspace';

class ScormModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      submitEnabled: false,
      networkError: false,
      title: props.title || '',
      description: props.description || '',
      uploadSuccessful: false,
      version: null,
      scormId: props.scormId || null,
      lessonId: props.lessonId || null,
      errorTooltip: null,
      popout: props.popout || false,
      finishButton: props.finish || false,
      restart: props.restart || 'WHEN_NEWER_PACKAGE_VERSION_EXISTS',
      workspaceId: props.workspaceId || '',
      fullWidth: props.fullWidth || false,
      updating: !!props.scormId,
    };
    this.cancelScormCreate = this.cancelScormCreate.bind(this);
    this.createScormLesson = this.createScormLesson.bind(this);
    this.deleteLesson = this.deleteLesson.bind(this);
    this.resetErrors = this.resetErrors.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.setUploading = this.setUploading.bind(this);
    this.setUploadSuccessful = this.setUploadSuccessful.bind(this);
    this.setUploadFailed = this.setUploadFailed.bind(this);
    this.setIds = this.setIds.bind(this);
    this.togglePopout = this.togglePopout.bind(this);
    this.toggleFinishButton = this.toggleFinishButton.bind(this);
    this.toggleFullWidth = this.toggleFullWidth.bind(this);
    this.onWorkspaceChange = this.onWorkspaceChange.bind(this);
    this.onRestartChange = this.onRestartChange.bind(this);
  }

  componentDidMount() {
    this.validateLesson();
  }

  createScormLesson(e) {
    e.preventDefault();
    this.setState(
      {
        submitEnabled: false,
      },
      () => {
        request
          .put(
            routes.SCORM_UPLOADED(this.state.scormId),
            {
              title: this.state.title,
              description: this.state.description,
              popout: this.state.popout,
              finish: this.state.finishButton,
              restart: this.state.restart,
              display_full_width: this.state.fullWidth,
              workspace_id: this.state.workspaceId,
              upload_successful: this.state.uploadSuccessful,
            },
            { dataType: 'text' },
          )
          .then(() => {
            const lessonUrl = routes.LESSON(this.state.lessonId);
            window.location.assign(lessonUrl);
          })
          .fail(() => {
            this.setState({
              networkError: t('common.error'),
              submitEnabled: true,
            });
          });
      },
    );
  }

  deleteLesson() {
    if (this.state.scormId && this.state.version !== null) {
      request.delete(routes.SCORM_CANCEL(this.state.scormId), {
        version: this.state.version,
      });
      this.setState({
        scormId: null,
        lessonId: null,
      });
    }
  }

  cancelScormCreate() {
    this.deleteLesson();
    this.props.closeScormModal();
  }

  resetErrors() {
    this.setState({ networkError: false });
  }

  setUploading() {
    this.setState({
      submitEnabled: false,
    });
  }

  setUploadSuccessful(version) {
    this.setState(
      {
        uploadSuccessful: true,
        networkError: false,
        version,
      },
      this.validateLesson,
    );
  }

  setUploadFailed(message) {
    this.setState(
      {
        uploadSuccessful: false,
        networkError: `${t('common.error')}: ` + message,
        submitEnabled: false,
      },
      this.validateLesson,
    );
  }

  setIds(lessonId, scormId) {
    this.setState({
      lessonId,
      scormId,
    });
  }

  handleInputChange(e) {
    const { name, value } = e.target;
    this.setState({ [name]: value }, this.validateLesson);
  }

  onWorkspaceChange(e) {
    this.setState({ workspaceId: e.target.value });
  }

  onRestartChange(e) {
    this.setState({ restart: e.target.value });
  }

  togglePopout() {
    this.setState(state => ({
      popout: !state.popout,
    }));
  }

  toggleFinishButton() {
    this.setState(state => ({
      finishButton: !state.finishButton,
    }));
  }

  toggleFullWidth() {
    this.setState(state => ({
      fullWidth: !state.fullWidth,
    }));
  }

  validateLesson() {
    const { title, lessonId, uploadSuccessful, updating } = this.state;
    const hasTitle = title.trim().length > 0;

    let errorTooltip;
    if (!hasTitle && !lessonId && !updating) {
      errorTooltip = t('contents.index.scorm.tooltips.no_name_or_file');
    } else if (!hasTitle) {
      errorTooltip = t('contents.index.scorm.tooltips.no_name');
    } else if (!lessonId && uploadSuccessful === false) {
      errorTooltip = t('contents.index.scorm.tooltips.no_file');
    }

    this.setState({
      submitEnabled: hasTitle && (updating || uploadSuccessful),
      errorTooltip,
    });
  }

  render() {
    const { workspaces, hasWorkspaceFeature } = this.props;
    const { scormId, lessonId, updating } = this.state;
    const canAssignWorkspace = hasWorkspaceFeature && workspaces.length > 1;

    return (
      <ModalContainer
        className="ModalTakeover-background Modal-background"
        onEscape={this.cancelScormCreate}
      >
        <div className="LessonCreationModal ModalTakeover-container">
          <div className="LessonCreationModal-body">
            <form onSubmit={this.createScormLesson}>
              <div className="LessonCreationModal-title">
                {updating
                  ? t('contents.index.scorm.update_scorm')
                  : t('contents.index.scorm.create_new')}
              </div>
              <label
                htmlFor="lesson-title"
                className="LessonCreationModal-inputTitle"
              >
                {t('common.title')}
              </label>
              <input
                id="lesson-title"
                className="NewInput NewInput--white NewInput--fw ModalTakeover-nameInput"
                placeholder={t('contents.index.scorm.give_name')}
                type="text"
                name="title"
                value={this.state.title}
                onChange={this.handleInputChange}
              />
              <label
                htmlFor="description"
                className="LessonCreationModal-inputTitle"
              >
                {t('common.description')}
              </label>
              <textarea
                id="description"
                name="description"
                value={this.state.description}
                className="NewInput NewInput--white NewInput--fw"
                placeholder={t('common.enter_description')}
                rows="3"
                onChange={this.handleInputChange}
              />
              {canAssignWorkspace && (
                <div>
                  <label
                    htmlFor="workspace"
                    className="LessonCreationModal-inputTitle"
                  >
                    {t('workspaces.workspace')}
                  </label>
                  <SelectWorkspace
                    workspaces={workspaces}
                    onChange={this.onWorkspaceChange}
                  />
                </div>
              )}
              <label
                htmlFor="description"
                className="LessonCreationModal-inputTitle"
              >
                {t('contents.index.scorm.scorm_package')}
              </label>
              {this.state.networkError && (
                <span className="ErrorContainer ErrorContainer--bold Animated--fadeIn d-f ai-c">
                  <Icon name="warning_sign" className="mr-8" />
                  {this.state.networkError}
                </span>
              )}
              <ScormUploader
                deleteLesson={this.deleteLesson}
                setUploading={this.setUploading}
                setUploadSuccessful={this.setUploadSuccessful}
                setUploadFailed={this.setUploadFailed}
                setIds={this.setIds}
                setVersion={this.setVersion}
                scormModalVisible={this.props.scormModalVisible}
                resetErrors={this.resetErrors}
                scormId={scormId}
                lessonId={lessonId}
                updating={updating}
              />
              {updating && (
                <div>
                  <label
                    htmlFor="restart"
                    className="LessonCreationModal-inputTitle"
                  >
                    {t('contents.index.scorm.scorm_restart.title')}
                  </label>
                  <Select
                    name="restart"
                    id="restart"
                    value={this.state.restart}
                    onChange={this.onRestartChange}
                    fullWidth
                  >
                    <option
                      key="WHEN_NEWER_PACKAGE_VERSION_EXISTS"
                      value="WHEN_NEWER_PACKAGE_VERSION_EXISTS"
                    >
                      {t('contents.index.scorm.scorm_restart.always')}
                    </option>
                    <option
                      key="WHEN_EXISTING_REG_IS_INCOMPLETE_AND_NEWER_PACKAGE_VERSION_EXISTS"
                      value="WHEN_EXISTING_REG_IS_INCOMPLETE_AND_NEWER_PACKAGE_VERSION_EXISTS"
                    >
                      {t('contents.index.scorm.scorm_restart.incomplete')}
                    </option>
                    <option key="NEVER" value="NEVER">
                      {t('contents.index.scorm.scorm_restart.never')}
                    </option>
                  </Select>
                </div>
              )}
              <div>
                <label
                  htmlFor="description"
                  className="LessonCreationModal-inputTitle"
                >
                  {t('contents.index.scorm.learning_experience')}
                </label>
                {withTooltip({
                  text: t('contents.index.scorm.tooltips.popout'),
                })(
                  <div>
                    <input
                      id="popout"
                      name="popout"
                      type="checkbox"
                      onChange={this.togglePopout}
                      checked={this.state.popout}
                    />
                    <label className="ml-4" htmlFor="popout">
                      {t('contents.index.scorm.open_in_new_window')}
                    </label>
                  </div>,
                )}
                <div>
                  <input
                    id="finishButton"
                    name="finishButton"
                    type="checkbox"
                    onChange={this.toggleFinishButton}
                    checked={this.state.finishButton}
                  />
                  <label className="ml-4" htmlFor="finishButton">
                    {t('contents.index.scorm.add_nav_finish')}
                  </label>
                </div>
                <div>
                  <input
                    id="fullWidth"
                    name="fullWidth"
                    type="checkbox"
                    onChange={this.toggleFullWidth}
                    checked={this.state.fullWidth}
                  />
                  <label className="ml-4" htmlFor="fullWidth">
                    {t('contents.index.scorm.display_full_width')}
                  </label>
                </div>
              </div>
              <ButtonGroup alignEnd className="mt-8">
                {withTooltip({ text: this.state.errorTooltip })(
                  <Button
                    type="submit"
                    customColor
                    disabled={
                      !this.state.submitEnabled || this.state.networkError
                    }
                  >
                    {updating
                      ? t('actions.update_scorm')
                      : t('contents.index.scorm.create')}
                  </Button>,
                )}
              </ButtonGroup>
            </form>

            <button
              className="ModalTakeover-closeButton u-resetBtn"
              onClick={this.cancelScormCreate}
              aria-label={t('common.close')}
              type="button"
            >
              <Icon name="error" />
            </button>
          </div>
        </div>
      </ModalContainer>
    );
  }
}

export default ScormModal;
